export const isCorporateExternalTransportMobileUser = (value: any) => Boolean(
  value?.externalTransportAccountUserId ||
  value?.external_transport_account_user_id ||
  value?.originalRole === 'corporate-external-transport-user'
);
